import { configureStore } from '@reduxjs/toolkit'
import { StoreReducer } from './reducer'
import { syncMiddleware, listenToExternalState } from './syncMiddleware'
import { RemoveElementValidationMiddleware } from './remove-validation-middleware'
import { workflowValidatorMiddleware } from './workflow-validator-middleware'
import { pausedJourneyMiddleware } from './paused-journey-middleware'

/**
 * Configures and creates the Redux store.
 * @type {Store}
 */
export const store = configureStore({
  reducer: new StoreReducer().getReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    }).concat([pausedJourneyMiddleware, syncMiddleware, RemoveElementValidationMiddleware, workflowValidatorMiddleware])
})

// Start listening to external state updates
listenToExternalState(store)
